import {
  Box,
  Paper,
  Typography,
  Container,
  useTheme,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ForgotPasswordForm from "../forms/ForgotPasswordForm";

const ForgotPasswordPage: React.FC = () => {
  const theme = useTheme();
  return (
    <Container
      maxWidth="sm"
      sx={{ py: 10, display: "flex", justifyContent: "center" }}
    >
      <Paper
        elevation={24}
        sx={{
          p: 5,
          borderRadius: theme.appRadius.xl,
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontWeight: "bold",
          }}
        >
          Recover Password
        </Typography>
        <ForgotPasswordForm />
        <Box sx={{ mt: 3 }}>
          <Link
            component={RouterLink}
            to="/login"
            variant="body2"
            color="secondary"
          >
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};
export default ForgotPasswordPage;
